import React from 'react';
import { useProfile, getUtmSource } from 'providers/profile.provider';
import { ESTIMULO_2020, AMBEV, PRODUCTS_WITHOUT_PARTNERS_HEADER_NAME } from 'constants/constants';
import { useProduct } from 'providers/product.provider';
import bizLogo from 'assets/img/biz-capital-logo-2019.png';
import bizPartnerLogo from 'assets/svg/biz-capital-parceiro-logo.svg';

const check =
    '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6"><path fill="#FFF" fill-rule="nonzero" d="M1.648 2.382A1 1 0 0 0 .352 3.906l2.184 1.856a1 1 0 0 0 1.371-.072l3.817-4A1 1 0 0 0 6.277.31L3.112 3.627 1.648 2.382z"/></svg>';

export const PartnerLogo = ({ url }) => {
    const { loanApplicationUtmSource } = useProfile();
    const { isPreApproved, productBizId } = useProduct();

    const useBizProductLogo = () => isPreApproved || PRODUCTS_WITHOUT_PARTNERS_HEADER_NAME.includes(getUtmSource());
    const partnersLogoClass = productBizId || loanApplicationUtmSource || ([AMBEV, ESTIMULO_2020].includes(getUtmSource()) ? getUtmSource() : 'partner-logo');

    return (
        <div className="partner-logo-container">
            {
                useBizProductLogo() &&
                (
                    <>
                        <img src={bizLogo} className="bizcap-logo-product" />
                        <span className="bizcap-logo-product-divisor" />
                    </>
                )
            }
            {
                !useBizProductLogo() &&
                (
                    <>
                        <img src={bizPartnerLogo} className="bizcap-logo-partner" />
                        <span className="bizcap-logo-partner-divisor" />
                    </>
                )
            }


            <img src={url} className={partnersLogoClass} />
        </div>
    )
};

export const MobileSteps: React.FC<{ elements: any[] }> = ({
    elements,
}): JSX.Element => (
        <>
            {elements.map((step, key: number) => (
                <React.Fragment key={key}>
                    <span
                        className={step.className}
                        dangerouslySetInnerHTML={{
                            __html: step.className === 'completed' ? check : '',
                        }}
                    />
                    {step.className === 'active' && (
                        <label>{step.label}</label>
                    )}
                </React.Fragment>
            ))}
        </>
    );

export const DesktopSteps: React.FC<{ elements: any[] }> = ({
    elements,
}): JSX.Element => (
        <>
            {elements.map(({ label, className }, key: number) => (
                <div className={className} key={key}>
                    <span
                        className="bullet"
                        dangerouslySetInnerHTML={{
                            __html: className === 'completed' ? check : '',
                        }}
                    />
                    <label>{label}</label>
                </div>
            ))}
        </>
    );

export const PartnerHeaderStyle = ({ partnerUrl }) => (
    <nav className="header">
        <div className="inner">
            <PartnerLogo url={partnerUrl} />
        </div>
        <div className="partner-header-separator" />
    </nav>
);

export const DefaultHeaderStyle = () => (
    <nav className="header">
        <div className="inner">
            <img
                src={bizLogo}
                className="bizcap-logo"
            />
        </div>
    </nav>
);

export const LoadingContainer: React.FC = (): JSX.Element => (
    <nav className="header">
        <div className="inner" />
    </nav>
);
